import { FC, useCallback } from 'react';

import { useConfigSlice } from '@pp/core/src/store/slices/config/selectors';
import { useSettingsSlice } from '@pp/core/src/store/slices/settings/selectors';
import { roundNumber } from '@pp/core/src/utils/number';

import { useGameDispatch } from '../../store/GameStore';
import { autoCashoutActions } from '../../store/slices/autocashout/slice';
import { highflyerGameStateActions } from '../../store/slices/highflyerGame/slice';
import { useValidCashoutMultiplierConnected } from '../gameGrid/hooks/useValidCashoutMultiplierConnected';
import { VirtualKeypad } from '../virtualKeypad/VirtualKeypad';

export interface VirtualKeypadProps {
  betCode: number;
}

export const VirtualCashoutKeypadConnected: FC<VirtualKeypadProps> = ({ betCode }) => {
  const { inputFieldValue, actualMultplier } = useValidCashoutMultiplierConnected(betCode);
  const minLimits = 1.01;
  const customMultiplierCap = useConfigSlice.tableConfig();
  const maxLimits = customMultiplierCap?.customMultiplierCap ? customMultiplierCap.customMultiplierCap : 100;
  const dispatch = useGameDispatch();
  const currentLanguage = useSettingsSlice.currentLanguage();

  const handleDispatch = useCallback((updatedPriceValue: string) => {
    const finalCashoutInput = updatedPriceValue;
    dispatch(
      autoCashoutActions.setCashoutMultiplier({
        betCode: betCode,
        cashoutMultiplier: finalCashoutInput.toString(),
      })
    );
  }, []);

  const handleQuickBet = useCallback(
    (betId: number, priceValue: string): void => {
      dispatch(
        autoCashoutActions.setCashoutMultiplier({
          betCode: betId,
          cashoutMultiplier: roundNumber(parseFloat(priceValue), 2).toFixed(2),
        })
      );
      dispatch(highflyerGameStateActions.setToggleKeypad({ autoCashOut: false, betCode: betCode }));
    },
    [dispatch]
  );

  return (
    <VirtualKeypad
      betCode={betCode}
      maxLimits={maxLimits}
      minLimits={minLimits}
      betLabel="AUTO_CASHOUT"
      betInputAmount={actualMultplier}
      betInputValue={inputFieldValue}
      handleQuickBet={handleQuickBet}
      handleDispatch={handleDispatch}
      showFormatter={true}
      formatter="x"
      currentLanguage={currentLanguage}
    />
  );
};
